import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin settingsManager/services/ReportService";

/**
 * Gets configured scheduled reports list.
 */
export const listScheduledReports = async () => {
	try {
		let response = await axios.get(`${APIGateways.reportEndpoint}`, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error getting configured scheduled report.`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENT_STATUS_ALERTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};

/**
 * Sends the list of new scheduled report configurations to the backend lambda
 * where they will be updated, removed, or created in the dynamo.
 * @param {Object} scheduledReport The array of scheduled report.
 * @returns The updated list of scheduledReports reports
 */
export const updateScheduledReports = async (reports) => {
	try {
		let response = await axios.post(`${APIGateways.reportEndpoint}`, reports, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error getting configured scheduled reports`, {
			additionalData: {
				error: errorToObject(error),
			},
			logCode: errorCodes.GET_AGENT_STATUS_ALERTS_API_ERROR,
			componentName: COMPONENT_NAME,
		});
		throw error;
	}
};
